import type { RouteRecordRaw } from 'vue-router'

export const externalReservationsRoutes: RouteRecordRaw[] = [
  {
    path: '/external-reservations',
    name: 'external-reservations',
    component: () => import('./views/ExternalReservationsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
]
